import React from "react";
import { AlertTriangle, X } from "lucide-react";
import "./DeleteApprovalTeamModal.css";

export default function RemoveAllMembersModal({
  open,
  onDelete,
  onCancelRemoval,
}) {
  if (!open) return null;

  return (
    <div className="jfm-overlay" onClick={onCancelRemoval}>
      <div
        className="jfm-container dtm-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dtm-header">
          <div className="dtm-header-icon">
            <AlertTriangle size={20} />
          </div>
          <div>
            <h3 className="dtm-header-title">Remove All Members</h3>
          </div>
          <button
            className="jfm-close"
            onClick={onCancelRemoval}
            style={{ marginLeft: "auto" }}
          >
            <X size={18} />
          </button>
        </div>

        <div className="dtm-body">
          <p className="dtm-prompt">
            Removing all members of a team requires the team to be deleted. How
            do you want to proceed?
          </p>
        </div>

        <div className="jfm-footer">
          <div />
          <div className="jfm-footer-actions">
            <button className="jfm-cancel" onClick={onCancelRemoval}>
              Cancel Removal
            </button>
            <button className="dtm-delete-btn" onClick={onDelete}>
              Delete Approval Team
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
